"use strict";
$(function ($) {
  sessionceck();

  /* アンカーリンクアニメーション */


  $(function () {
    //↓　80px分ずらしたい場合
    var headerHight = 80;
    $('a[href^="#"]').click(function () {
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? "html" : href);
      var position = target.offset().top - headerHight;
      $("html, body").animate({ scrollTop: position }, 1000, "linear");
      return false;
    });
  });

  /*======================================
  ハンバーガーメニュー  
  ======================================*/

  $(".js-drawer").on("click", function () {
    $(
      ".js-nav, .js-drawer, .p-header__menuBar, .p-header__snsWrapper"
    ).toggleClass("is-open");
  });
  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $(".js-nav a[href]").on("click", function () {
    $(".js-drawer").trigger("click");
  });
  // ハンバーガーメニュー開いている時のスクロールを禁止する
  let state = false;
  let pos;
  $(".js-drawer").on("click", function () {
    if (state == false) {
      pos = $(window).scrollTop();
      $("body").css("overflow", "hidden");
      state = true;
    } else {
      $("body").css("overflow", "auto");
      window.scrollTo(0, pos);
      state = false;
    }
  });

  /* ページトップ */
  $(document).on("click", '#scroll[data-scroll="pagetop"]', function () {
    $("body,html").animate({ scrollTop: 0 }, 400, "swing");
  });

  /* スクロールとページトップの切り替え */
  $(window).on("scroll load", function () {
    let pMvTop = $(".p-mv").offset().top; // .p-mv要素のページ上部からの距離
    let pMvHeight = $(".p-mv").outerHeight(); // .p-mv要素の高さ（paddingやborderも含む）
    let pMvBottom = pMvTop + pMvHeight; // .p-mv要素のページ下部からの距離

    let windowTop = $(window).scrollTop();

    if (windowTop > pMvBottom) {
      // .p-mvを過ぎた場合の処理
      $("#scroll").attr("data-scroll", "pagetop");
    } else {
      // .p-mvを通過していない場合の処理
      $("#scroll").attr("data-scroll", "scroll");
    }
  });

  /*======================================
    menuセクション追従バー色変更  
  ======================================*/
  $(function () {
    $(window).scroll(function () {
      if ($(window).width() >= 768) {
        // 画面幅が768px以上の場合のみ実行
        var scrollPos = $(window).scrollTop();
        var menuOffset = $("#menu").offset().top - 150;
        var knowOffset = $("#know").offset().top - 77;

        // セクション２から３の間はこれ
        if (scrollPos > menuOffset && scrollPos < knowOffset) {
          $(".p-header__snsWrapper, #scroll .scrollItem span").css(
            "filter",
            "brightness(0) saturate(100%) invert(100%) sepia(93%) saturate(0%) hue-rotate(201deg) brightness(106%) contrast(106%)"
          );
        }
        // セクション３より進んだらこれ
        else if (scrollPos > $("#know").offset().top) {
          $(".p-header__snsWrapper, #scroll .scrollItem span").css(
            "filter",
            "initial"
          );
        }
        // それ以外（つまりセクション１である場合）はこれ
        else {
          $(".p-header__snsWrapper, #scroll .scrollItem span").css(
            "filter",
            "initial"
          );
        }
      } else {
        // 画面幅が768px未満の場合は初期化する
        $(".p-header__snsWrapper, #scroll .scrollItem span").css(
          "filter",
          "brightness(0) saturate(100%) invert(100%) sepia(93%) saturate(0%) hue-rotate(201deg) brightness(106%) contrast(106%)"
        );
      }
      // .js-drawerクラスを持つ要素がクリックされた時の処理
      $(".js-drawer").on("click", function () {
        // .p-header__snsWrapperがis-openクラスを持っている場合の条件
        if ($(".p-header__snsWrapper").hasClass("is-open")) {
          // フィルターを適用するスタイルを設定
          $(".p-header__snsWrapper.is-open").css(
            "filter",
            "brightness(0) saturate(100%) invert(100%) sepia(93%) saturate(0%) hue-rotate(201deg) brightness(106%) contrast(106%)"
          );
        } else if (!$(".p-header__snsWrapper").hasClass("is-open")) {
          // フィルターを解除するスタイルを設定
          $(".p-header__snsWrapper").css("filter", "initial");
        }
      });
    });
  });

  /* 日本地図 */
  $("#sakagura .pin").on("click", function () {
    let region = $(this).attr("data-pinregion");
    $("#sakagura .sakagraMap").attr("data-region", region);
  });

  $("#sakagura .materialImg").on("click", function () {
    let region = $(this).attr("data-mat");
    let targetNum = Number($(this).attr("data-regNum"));
    let targetSlide = $('.region_slide[data-rs="' + region + '"]');

    $("#modal").attr("data-modaltype", "region").fadeIn();
    $("#modal_region").attr("data-region", region);

    targetSlide.slick("slickGoTo", targetNum, true);
  });

  /* 地方スライド */
  $(".region_slide").not('[data-rs="hokkaido"]').slick({
    fade: false,
    autoplay: false,
    arrows: true,
    dots: false,
    speed: 1000,
    cssEase: "ease",
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    prevArrow:
      '<img src="img/region_prev.svg" alt="" class="slide-arrow prev-arrow">',
    nextArrow:
      '<img src="img/region_next.svg" alt="" class="slide-arrow next-arrow">',
  });

  /* floatバナー */
  $(".questionnaireBnr .closeBtn").on("click", function () {
    $(".questionnaireBnr").fadeOut();
  });

  /* モーダル */
  $("#modal .modalClose,#modal #modalInner").on("click", function () {
    $("#modal").fadeOut("normal", function () {
      $("#modal").attr("data-modaltype", "");
      $("#modal_region").attr("data-region", "");
    });
  });

  $(".modalContents").on("click", function (event) {
    event.stopPropagation();
  });
});

/*======================================
  モーダル  
======================================*/
MicroModal.init({
  awaitCloseAnimation: true,
  awaitOpenAnimation: true,
  // disableScroll: true
});

/*======================================
  スライダー  
======================================*/
document.addEventListener("DOMContentLoaded", function () {
  var swiper;
  // 有効化時のオプションを記述
  function initializeSwiper() {
    swiper = new Swiper(".swiper", {
      loop: true,
      centeredSlides: true,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
  // 無効化する用の記述
  function destroySwiper() {
    if (swiper) {
      swiper.destroy();
      swiper = undefined;
    }
  }
  // if分を用いて横幅に応じて関数を実行
  function handleResize() {
    var w =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    if (w < 768) {
      if (!swiper) {
        initializeSwiper();
      }
    } else {
      destroySwiper();
    }
  }
  // 初回実行
  handleResize();
  window.addEventListener("resize", handleResize);
});

/*======================================
  AOS  
======================================*/
AOS.init();

/* セッションチェック */
function sessionceck() {
  let age = sessionStorage.getItem("overage");

  if (age == 20) {
    agececkClose();
  } else {
    agececkOpen();
  }
}

/* 年齢チェック */
function agececk(b) {
  if (b == "yes") {
    agececkClose();
  } else {
    window.location.href = "https://www.honkakushochu-awamori.jp/";
  }
}

function agececkOpen() {
  $("body").attr("data-agecheck", "false");
}

function agececkClose() {
  sessionStorage.setItem("overage", "20");
  $("body").attr("data-agecheck", "true");

  AOS.init({
    duration: 1400,
    easing: "ease-out-sine",
  });

  let $mainSlide = $(".mainSlide");
  let prevNum = 0;
  const activeClass = "sliact";

  setTimeout(function () {
    $mainSlide
      .on("init", function () {
        $mainSlide.delay(300).queue(function () {
          let nextNum = prevNum + 1;
          $(
            ".mainSlide-cell.cell-" + zeroPadding(nextNum, 2),
            $mainSlide
          ).addClass(activeClass);
          $mainSlide.slick("slickPlay");
        });
      })
      .slick({
        fade: true,
        autoplay: false,
        arrows: false,
        dots: false,
        speed: 1000,
        cssEase: "ease",
        autoplaySpeed: 8000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        let nextNum = nextSlide + 1;
        let nextItem = $(
          ".mainSlide-cell.cell-" + zeroPadding(nextNum, 2),
          $mainSlide
        );
        nextItem.addClass(activeClass);
        prevNum = currentSlide;
      })
      .on("afterChange", function (event, slick, currentSlide) {
        let pNum = prevNum + 1;
        let prevItem = $(
          ".mainSlide-cell.cell-" + zeroPadding(pNum, 2),
          $mainSlide
        );
        prevItem.removeClass(activeClass);
      });
  }, 2000);

  function zeroPadding(NUM, LEN) {
    return (Array(LEN).join("0") + NUM).slice(-LEN);
  }
}
